/**
 * Strips AEM-specific path prefix from URLs and returns the clean application route
 * @param aemPath - The full AEM path (e.g., '/content/ee/business/en/ee-basket?session=false')
 * @returns Clean application route (e.g., '/ee-basket?session=false')
 */
export const stripAemPrefix = (aemPath: string): string => {
  if (!aemPath || typeof aemPath !== 'string') {
    return aemPath;
  }
  const aemPrefixPattern = /^\/content\/ee\/business\/en/;

  return aemPath.replace(aemPrefixPattern, '');
};

/**
 * Processes an object recursively to strip AEM prefixes from all string values
 * @param obj - Object to process
 * @returns Processed object with clean paths
 */
export const stripAemPrefixFromObject = <T>(obj: T): T => {
  if (typeof obj === 'string') {
    return stripAemPrefix(obj) as T;
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => stripAemPrefixFromObject(item)) as T;
  }

  if (obj && typeof obj === 'object') {
    const processed = {} as T;
    for (const [key, value] of Object.entries(obj)) {
      (processed as Record<string, unknown>)[key] =
        stripAemPrefixFromObject(value);
    }
    return processed;
  }

  return obj;
};
